// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__1SA8M","logo":"Logo_logo__1jwas","phocuswright":"Logo_phocuswright__3sVso"};